import React, { Component } from 'react';
import { toJS, reaction,runInAction } from 'mobx';
import { SearchBar, PullRefresh, ProgressState } from '../../index';
import RefList from './refList';
import './index.less';
import tools from '../../utils/tools';
import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { Icon } from 'antd-mobile';
import store from './store';
import { TopNavPage ,NavUtils} from 'mutants-mobile-navigator';


@observer
@TopNavPage
class RefPageView extends Component {


  // static propTypes = {
  //   fieldType: PropTypes.string, // 枚举还是参照 Enum
  //   codename: "",
  //   dropDownGridMatchMode: PropTypes.number,
  //   intCurrentPage: 0,
  //   intPageSize: PropTypes.string,
  //   likeFields: "",
  //   menuCode: null,
  //   refObject: PropTypes.string, // DTO 名称
  //   showField: "",
  //   showFields: "Name",
  //   sortby: "Code,ID",
  //   strDisabledControlVale: "False",
  //   strWhere: PropTypes.string,
  //   __sign: PropTypes.string
  // }

  // static defaultProps  = {
  //   fieldType: "",
  //   codename: "",
  //   dropDownGridMatchMode: 4,
  //   intCurrentPage: 0,
  //   intPageSize: "7",
  //   likeFields: "",
  //   menuCode: null,
  //   refObject: "CurrencyDTO",
  //   showField: "",
  //   showFields: "Name",
  //   sortby: "Code,ID",
  //   strDisabledControlVale: "False",
  //   strWhere: "Q3VycmVuY3lEVE8uRGlzYWJsZWQgPSAw",
  //   __sign: "1a6e645a044d95c797f8debbd55efa6f",
  // }


  navRightContent() {
    return (
      <div className='navRight'>
        <div className='' onClick={this.clearRightButton}>清空</div>
      </div>
    )
  }

  clearRightButton = () => {
    if (this.store.isCustomize) {
      this.handleSelect(null)
    } else {
      this.handleSelect({ Id: null, Name: null, Code: null })
    }
  }

  isBottomLine = false

  navTitle() {
    return this.store.title || '参照';
  }

  pageBackReceiveResult(action, result) {
    // console.log('inventorylist => ', action, result)
    // this.store.changeFilterParams('ClassID', result.level);

    // reftree 返回的类别
    this.store.loadNext(value, result.ClassID);
  }

  constructor(props) {
    super(props);
    console.log('props=======', props);
    this.store = new store();
    let { opt } = this.props.location.state;
    if (this.store) {
      this.store.load(opt);
      console.log(this.props.location.state);
    }
    this.state = {
      searchValue: ''
    }
    this.template = opt.RefColumns || null;
    this.RefShowField = opt.RefShowField;
  }




  clearSelecteds = () => {
    this.clear();
    this.ok();
  }

  clear = (e) => {
    tools.preventEvent(e);
    this.store.clearSelecteds();
  }

  ok = (e) => {
    // console.log('参照 返回的数据 => ', this.store.selecteds);

    if (this.props.location.state.backResultKey && (this.store.multiSelect || this.store.opt.refCallBack)) {
      NavUtils.popAndReturn('ok', {
        type: 'refMultiOK',
        filedInfo: this.props.location.state.filedInfo,
        selected: toJS(this.store.selecteds)
      }, this.props.location.state.backResultKey);
      return;
    }

    this.popAndReturn('ok', {
      type: 'refOK',
      filedInfo: this.props.location.state.filedInfo,
      selected: toJS(this.store.selecteds)
    });
  }

  goBack = () => {
    this.context.pop();
  }

  clearError = () => {
    this.store.clearError();
    this.context.pop();
  }

  handleLoadMore = (afterMore) => {
    this.store.loadNext(this.state.searchValue).then(() => {
      afterMore && afterMore(this.store.displayData.length);
    });
  }

  handleChange = (value) => {
    this.setState({
      searchValue: value
    })
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.timer = null;
      this.store.loadNext(this.state.searchValue, '');
    }, 1000);
  }

  handleScan = async(value)=>{
    const data = await this.store.loadNext(value, '');
    if(data && data.length==1 && this.store.selecteds && this.store.selecteds.length ==0){
      runInAction(() => {
        if(this.store.isCustomize){
          this.store.selecteds.push(data[0][0]);
        }else{
          this.store.selecteds.push(data[0]);
        }
        this.ok();
      });
      
    }
  }

  handleSelect = (value) => {
    this.store.select(value);
    if (!this.store.multiSelect) {
      this.ok();
    }else{
      if(value == null || value.ID == null){
        this.store.clearSelecteds();
      }
    }
  }

  itemRender = (rowData, sectionID, rowID) => {
    return <RefList
      template={this.template}
      RefShowField={this.RefShowField}
      rowID={rowID}
      isCustomize={this.store.isCustomize}
      items={[this.store.displayData[rowID]]}
      desensitizationFileds = {this.store.desensitizationFileds}
      getDesensitizationInfo = {this.store.getDesensitizationInfo}
      isMultiSelect={this.store.multiSelect}
      onSelected={this.handleSelect}
      selecteds={toJS(this.store.selecteds)} />
  };

  genData = (dataSize) => {
    const dataArr = []; 
    for (let i = 0; i < dataSize; i++) {
      const item = this.store.displayData[i];
      this.store.isCustomize ? dataArr.push(`row - ${item.returnValue} - selected - ${item.selected}`) :
      dataArr.push(`row - ${item.ID || item.Id} - ${this.store.refreshVersion} - selected - ${item.selected}`) 
    }
    return dataArr;
  }

  render() {
    const selecteds = this.store.selecteds;
    return (<div className='refPageComponent'><div className='refContent'>
      <SearchBar onScan = {this.handleScan} onChange={this.handleChange} value={this.state.searchValue || ''} placeholder={'请输入' + (this.store.title || '') + '名称'}></SearchBar>
      <ProgressState
        state={this.store.loaded ? 'show' : 'load'}
        empty={{ info: '亲，还没有相关的数据哦~' }}
        error={{ info: '哎呀, 发生错误了~' }}>
        <div className='body'>
          <PullRefresh
            dataSize={this.store.displayData.length}
            useBodyScroll={false}
            onMore={this.store.hasMore ? this.handleLoadMore : undefined}
            itemRender={this.itemRender}
            genData={this.genData}
            separatorStyle={{}}
            footerStyle={{ height: '5rem' }} />
        </div>
      </ProgressState>
    </div>
      {true == this.store.multiSelect && <div className='footer'><div className='cancel' onClick={this.clear}>重置</div><div className='ok' onClick={this.ok}>确定</div></div>}
    </div>)
  }
}
export default RefPageView;
